import { jsxs, jsx } from "react/jsx-runtime";
import { useContext, useRef, useEffect } from "react";
import { Box } from "../Box/Box.mjs";
import { RadioBarContext, RadioBarItemContext } from "./RadioBarContext.mjs";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { RADIOBAR_ITEM_CLICK, RADIOBAR_ITEM_FOCUSED, RADIOBAR_ITEM_TAB, RADIOBAR_ITEM_LEFT, RADIOBAR_ITEM_RIGHT, RADIOBAR_ITEM_UP, RADIOBAR_ITEM_DOWN, RADIOBAR_ITEM_SPACE } from "./RadioBar.actions.mjs";
import { normalizeKey } from "../private/normalizeKey.mjs";
import assert from "assert";
import { item, borderRecipe, borderColor, itemFocusRing } from "./RadioBar.css.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import "../ThemeProvider/ThemeProvider.mjs";
import "../ThemePortal/ThemePortal.mjs";
import "../Text/TextContext.mjs";
import "../ThemeProvider/ThemeContext.mjs";
import "../ThemeProvider/VanillaThemeContainer.mjs";
import "../private/DefaultMessagesContext.mjs";
import "../ThemeProvider/BreakpointContext.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import "../Box/BackgroundContext.mjs";
import "../Divider/Divider.css.mjs";
import "../Heading/HeadingContext.mjs";
import "../Hidden/Hidden.css.mjs";
import "../../css/negativeMargin/negativeMargin.css.mjs";
import "../Accordion/AccordionContext.mjs";
import { Text } from "../Text/Text.mjs";
import "../Columns/ColumnsContext.mjs";
import "../Column/Column.css.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import "../private/touchable/virtualTouchable.css.mjs";
import "../private/hideFocusRings/hideFocusRings.css.mjs";
import { Overlay } from "../private/Overlay/Overlay.mjs";
import "../Accordion/AccordionItem.css.mjs";
import "../Actions/ActionsContext.mjs";
import "../../css/textAlignedToIcon.css.mjs";
import "../Alert/Alert.css.mjs";
import "../Autosuggest/Autosuggest.mjs";
import "../Avatar/Avatar.css.mjs";
import "../Badge/Badge.mjs";
import "../Breadcrumb/Breadcrumb.css.mjs";
import "../Box/ColoredBox.mjs";
import "../Button/Button.mjs";
import "../ButtonIcon/ButtonIcon.mjs";
import "../ButtonLink/ButtonLink.mjs";
import "../private/Keyline/Keyline.css.mjs";
import "../Checkbox/Checkbox.mjs";
import "../Checkbox/CheckboxStandalone.mjs";
import "../ContentBlock/ContentBlock.css.mjs";
import "../DateField/DateField.mjs";
import "../private/Field/FloatingLabel.css.mjs";
import "../private/Field/Field.css.mjs";
import "../DateField/DateField.css.mjs";
import "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import "../private/Modal/ModalContext.mjs";
import "../TextLink/TextLink.mjs";
import "../TextLinkButton/TextLinkButton.css.mjs";
import "../private/AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../Dropdown/Dropdown.mjs";
import "../private/MaxLines/MaxLines.css.mjs";
import "../HiddenVisually/HiddenVisually.css.mjs";
import "../Link/Link.mjs";
import "../private/defaultTextProps.mjs";
import "../List/List.css.mjs";
import "../Loader/Loader.css.mjs";
import "../Skeleton/Skeleton.css.mjs";
import "../MenuRenderer/MenuRenderer.mjs";
import "../MenuItem/MenuItem.mjs";
import "../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../MenuItemDivider/MenuItemDivider.mjs";
import "../MenuItem/MenuItemLink.mjs";
import "../OverflowMenu/OverflowMenu.css.mjs";
import "../MonthPicker/MonthPicker.mjs";
import "../Pagination/Pagination.css.mjs";
import "../PasswordField/PasswordField.mjs";
import "../Pincode/Pincode.mjs";
import "../PopoverRenderer/PopoverRenderer.mjs";
import "../Pressable/Pressable.mjs";
import "../RadioGroup/RadioGroup.mjs";
import "../RadioGroup/RadioItem.mjs";
import "../RadioGroup/RadioItemBlock.mjs";
import "../SelectableList/SelectableList.css.mjs";
import "../private/BulkActions/BulkActions.css.mjs";
import "../Spread/Spread.css.mjs";
import "../Stepper/Step.mjs";
import "../Stepper/Stepper.mjs";
import "../Tabs/Tab.mjs";
import "../Table/Table.mjs";
import "../Table/Table.css.mjs";
import "../Tabs/TabsProvider.mjs";
import "../Tabs/TabListContext.mjs";
import "../Tabs/Tabs.css.mjs";
import "../Tabs/TabPanelsContext.mjs";
import "../Tag/Tag.css.mjs";
import "../Textarea/Textarea.mjs";
import "../TextDropdown/TextDropdown.css.mjs";
import "../TextField/TextField.mjs";
import "../Tiles/Tiles.css.mjs";
import "../Toggle/Toggle.mjs";
import "../useToast/ToastContext.mjs";
import "../TooltipRenderer/TooltipRenderer.mjs";
import "../TimeField/DateSegment.css.mjs";
import "../private/FieldButtonIcon/FieldButtonIcon.mjs";
import "../MultiStepModal/MultiStepModal.mjs";
import "../SearchField/SearchField.mjs";
import { vars } from "../../themes/vars.css.mjs";
import "./RadioBar.mjs";
const dividerSpacingForSize = {
  standard: "medium",
  small: "small"
};
const paddingXForTabSize = {
  standard: "small",
  small: "xsmall"
};
const RadioBarItem = ({
  value,
  children,
  icon,
  disabled,
  "aria-describedby": ariaDescribedBy,
  data,
  ...restProps
}) => {
  const radioBarContext = useContext(RadioBarContext);
  const radioBarItemContext = useContext(RadioBarItemContext);
  const radioBarItemRef = useRef(null);
  assert(
    radioBarContext !== null && radioBarItemContext !== null,
    "All `RadioBarItems` must be within a `RadioBar`."
  );
  const {
    id,
    name,
    value: fieldValue,
    disabled: fieldDisabled,
    itemsCount,
    onChange,
    dispatch,
    focusedItemIndex,
    tone,
    size
  } = radioBarContext;
  const { radioBarItemIndex } = radioBarItemContext;
  const isFirst = radioBarItemIndex === 0;
  const isLast = radioBarItemIndex === itemsCount - 1;
  const isSelected = fieldValue === value;
  const isFocused = focusedItemIndex === radioBarItemIndex;
  const isFirstRadioWithNoCheckedValueInGroup = radioBarItemIndex === 0 && !Boolean(fieldValue);
  const tababble = isSelected || isFirstRadioWithNoCheckedValueInGroup;
  const isDisabled = disabled || fieldDisabled;
  useEffect(() => {
    if (radioBarItemRef.current && isFocused) {
      radioBarItemRef.current.focus();
    }
  }, [isFocused, isSelected]);
  const onKeyDown = (event) => {
    const targetKey = normalizeKey(event);
    if (targetKey === "Tab" && focusedItemIndex !== null) {
      dispatch({ type: RADIOBAR_ITEM_TAB });
      return;
    }
    const isArrowPress = targetKey.indexOf("Arrow") === 0;
    const isActionKeyPress = targetKey === "Enter" || targetKey === " ";
    if (isArrowPress || isActionKeyPress) {
      event.preventDefault();
    }
  };
  const onKeyUp = (event) => {
    const targetKey = normalizeKey(event);
    if (targetKey === "Tab") {
      return;
    }
    if (onChange && (targetKey === "Enter" || targetKey === " ")) {
      onChange(value);
    }
    const action = {
      ArrowLeft: { type: RADIOBAR_ITEM_LEFT },
      ArrowRight: { type: RADIOBAR_ITEM_RIGHT },
      ArrowUp: { type: RADIOBAR_ITEM_UP },
      ArrowDown: { type: RADIOBAR_ITEM_DOWN },
      " ": { type: RADIOBAR_ITEM_SPACE, value: radioBarItemIndex }
    };
    if (action[targetKey]) {
      dispatch(action[targetKey]);
    }
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      id: `${id}_${radioBarItemIndex}`,
      component: "button",
      disabled: isDisabled,
      role: "radio",
      name,
      ref: radioBarItemRef,
      selected: isSelected,
      "aria-checked": isSelected,
      "aria-describedby": ariaDescribedBy,
      display: "flex",
      alignItems: "center",
      justifyContent: { mobile: "flexStart", tablet: "center" },
      textAlign: "left",
      cursor: isDisabled ? "not-allowed" : "pointer",
      background: isDisabled ? "disabled" : isSelected ? "formAccent" : void 0,
      outline: "none",
      position: "relative",
      "aria-label": children,
      width: "full",
      tabIndex: tababble ? 0 : -1,
      zIndex: 1,
      onClick: () => {
        dispatch({ type: RADIOBAR_ITEM_CLICK, value: radioBarItemIndex });
      },
      onFocus: () => {
        onChange(value);
        dispatch({ type: RADIOBAR_ITEM_FOCUSED, value: radioBarItemIndex });
      },
      onKeyDown,
      onKeyUp,
      paddingX: paddingXForTabSize[size],
      paddingY: dividerSpacingForSize[size],
      borderTopLeftRadius: isFirst ? "small" : void 0,
      borderTopRightRadius: {
        mobile: isFirst ? "small" : void 0,
        tablet: isLast ? "small" : "none"
      },
      borderBottomLeftRadius: {
        mobile: isLast ? "small" : void 0,
        tablet: isFirst ? "small" : "none"
      },
      borderBottomRightRadius: isLast ? "small" : void 0,
      className: [item, borderRecipe({ first: isFirst, last: isLast })],
      style: {
        ...assignInlineVars({
          [borderColor]: tone === "critical" ? vars.borderColor.critical : vars.borderColor.field
        }),
        opacity: isDisabled ? 0.5 : void 0
      },
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            component: "span",
            display: "block",
            position: "absolute",
            "aria-hidden": true,
            transition: "fast",
            opacity: isSelected ? 0 : void 0,
            children: /* @__PURE__ */ jsx(Text, { size, tone: "secondary", icon, children })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            component: "span",
            display: "block",
            transition: "fast",
            opacity: !isSelected ? 0 : void 0,
            background: "formAccent",
            children: /* @__PURE__ */ jsx(Text, { id: `${id}_${radioBarItemIndex}_label`, size, icon, children })
          }
        ),
        !isDisabled && /* @__PURE__ */ jsx(
          Overlay,
          {
            component: "span",
            zIndex: 1,
            boxShadow: "outlineFocus",
            borderRadius: "standard",
            className: itemFocusRing,
            visible: false,
            transition: "fast",
            onlyVisibleForKeyboardNavigation: true
          }
        )
      ]
    }
  );
};
export {
  RadioBarItem
};
